import api from "../../../../utils/api";

export const getAllDeletedUsers = (page = 0, limit = 10, search = "") => {
  return api.get(`/user/fetch/deleteUserRequest?page=${page}&size=${limit}${search ? `&search=${search}` : ""}`);
};